function removeUserFromUnapprovedArray({ state }) {
  let deleteUser = state.get('client.delete.user')
  if (deleteUser) {
    let users = state.get('users.unapproved')
    let filters = users.filter(user => {
      return user._id === deleteUser._id
    })
    if (filters && filters.length > 0) {
      state.splice('users.unapproved', users.indexOf(filters[0]), 1)
    }
  }
}

export default removeUserFromUnapprovedArray



// WEBPACK FOOTER //
// ./src/modules/user/actions/removeUserFromUnapprovedArray.js